import { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";

import { Option } from "@/@types/generics/Option";

import { SelectComponent } from "@/components/SelectComponent";
import { RequestedProceduresByProfessional } from "./RequestedProceduresByProfessional";
import { RequestedProceduresByPatient } from "./RequestedProceduresByPatient";
import { RequestedAndEvaluatedProcedures } from "./RequestedAndEvaluatedProcedures";
import { Card } from "react-bootstrap";
import { useLayout } from "@/../_metronic/layout/core";

export function GeneralProcedures() {
	const { setTitle } = useLayout();
	const [selectedReportOption, setSelectedReportOption] = useState<number | undefined>();

	const reportOptions: Option<number>[] = [
		{ label: "Exames/procedimentos solicitados por paciente", value: 1 },
		{ label: "Exames/procedimentos solicitados por profissional", value: 2 },
		{ label: "Exames/procedimentos solicitados e realizados", value: 3 },
	];

	function renderReportComponent(reportOption?: number) {
		switch (reportOption) {
			case 1:
				return <RequestedProceduresByPatient />;
			case 2:
				return <RequestedProceduresByProfessional />;
			case 3:
				return <RequestedAndEvaluatedProcedures />;
		}
	}

	useEffect(() => {
		setTitle("Listagem - Exames e Procedimentos");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="p-4">
			<Card className="h-100 shadow-sm">
				<Card.Body>
					<Row className="p-2">
						<Col>
							<InputGroup>
								<Form.Label>Tipo de relatório</Form.Label>
								<SelectComponent
									className="w-100"
									name="generalprocedures"
									options={reportOptions}
									onChange={(event) =>
										Boolean((event as Option<string>).value)
											? setSelectedReportOption(
													Number((event as Option<string>).value)
											  )
											: setSelectedReportOption(undefined)
									}
									defaultValue={{ value: "", label: "Escolha uma opção" }}
									noOptionsMessage={() =>
										"nenhum resultado encontrado na pesquisa"
									}
								/>
							</InputGroup>
						</Col>
					</Row>
					{renderReportComponent(selectedReportOption)}
				</Card.Body>
			</Card>
		</div>
	);
}
